import { useId } from 'react';
import * as S from './styles';

declare type CheckboxProps = {
    title: string;
    description?: string;
    required?: boolean;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

export default function Checkbox({ title, description, required, checked, onChange }: CheckboxProps) {
    const id = useId();

    return (
        <S.Container>
            <S.NativeCheckbox
                type="checkbox"
                id={id}
                checked={checked}
                required={required}
                onChange={(e) => onChange?.(e.target.checked)}
            />
            <S.TextWrapper>
                <S.Title htmlFor={id}>
                    {title}{required && <S.RequiredMark>*</S.RequiredMark>}
                </S.Title>
                {description && <S.Description>{description}</S.Description>}
            </S.TextWrapper>
        </S.Container>
    )
}
